<template>
  <div class="return">
    <div v-if="haveRight">
      <header class="warehousing-header">
        <h1 class="warehousing-username">
          <span>{{userInfo.worksite.shortName}} - {{userInfo.worksite.schoolCampus}}</span>
          <span class="worksite-info">
            <p class="school-name">（{{userInfo.nameZH}}）</p>
          </span>
        </h1>
      </header>
      <div class="weui-cells">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="chooseExpress">
          <div class="weui-cell__bd">
            <p>快递公司</p>
          </div>
          <div class="weui-cell__ft">{{currExpressCompany.name?currExpressCompany.name:'请选择'}}</div>
        </a>
      </div>

      <div class="empty-data" v-if="!haveData">
        <div>
          <i class="iconfont icon-similarproduct"></i>
        </div>
        <div>
          <p>暂无数据</p>
        </div>
      </div>
      <div class="return-list">
        <div class="return-item" v-for="item in toReturns" :key="item._id">
          <p class="return-express">{{item.expressCompany.name}}：{{item.expressNo}}</p>
          <p>
            <span class="item-middle-left_title">收件联系：</span>
            <span>{{item.receiver}}</span>
          </p>
          <p>
            <span class="item-middle-left_title">联系电话：</span>
            <span>{{item.receiverPhone}}</span>
          </p>
          <p>
            <span class="item-middle-left_title">取件编码：</span>
            <span>{{item.storageNo}}-{{item.tag}}</span>
          </p>
          <p>
            <span class="item-middle-left_title">到件时间：</span>
            <span>{{item.inTime}}</span>
          </p>
          <div class="scan-bnt" @click="scan(item)">
            <i class="iconfont icon-saomiaoshibie380"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import config from "../../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      worksiteId: "",
      userInfo: {
        worksite: {}
      },
      haveRight: false,
      currExpressCompany: {
        _id: "",
        name: ""
      },
      expressCompanies: [],
      ecPicker: [
        {
          label: "请选择",
          value: ""
        }
      ],
      toReturns: [],
      haveData: true,
      year: moment().format("YYYY")
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["scanQRCode"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });
    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let openid = response.data.data.openid;

        // 根据openid 获取用户信息
        axios
          .get("/auth/employee/getByOpen/" + openid)
          .then(res => {
            if (res.data.success) {
              const socket = io(config.socket, {
                transports: ["websocket"]
              });
              // 建立 socket 连接
              socket.on("connect", function() {
                console.log("socket.io connect...");
              });
              socket.on("reconnect_attempt", () => {
                socket.io.opts.transports = ["websocket", "polling"];
              });
              socket.on("expressTosendReturn", function(_id) {
                for (let i = 0; i < that.toReturns.length; i++) {
                  if (_id == that.toReturns[i]._id) {
                    that.toReturns.splice(i, 1);
                    return;
                  }
                }
                if (that.toReturns.length == 0) {
                  that.haveData = false;
                }
              });

              this.haveRight = true;
              this.userInfo = res.data.user;

              this.worksiteId = this.userInfo.worksite._id;
              let params = {
                worksiteId: this.worksiteId
              };
              axios
                .get("/api/expressTosend/toreturn", { params })
                .then(res => {
                  if (res.data.success) {
                    loading.hide(function() {});
                    this.toReturns = res.data.data;
                    if (this.toReturns.length == 0) {
                      this.haveData = false;
                    } else {
                      this.haveData = true;
                    }
                    for (let i = 0; i < this.toReturns.length; i++) {
                      this.toReturns[i].inTime = moment(
                        this.toReturns[i].createdAt
                      ).format("YYYY-MM-DD HH:mm");
                    }
                  } else {
                    loading.hide(function() {});
                    weui.alert("获取待退送列表失败");
                  }
                })
                .catch(err => {
                  loading.hide(function() {});
                  console.log(err);
                });

              let expressCompanyIds = this.userInfo.worksite.expressCompanies;
              params = {
                _id: {
                  $in: expressCompanyIds
                }
              };

              axios
                .get("api/expressCompany/list", { params })
                .then(response => {
                  this.expressCompanies = response.data.data;
                  for (let i = 0; i < this.expressCompanies.length; i++) {
                    let item = {
                      label: this.expressCompanies[i].name,
                      value: this.expressCompanies[i]._id
                    };
                    this.ecPicker.push(item);
                  }
                })
                .catch(error => {
                  weui.topTips("获取快递公司列表失败", 2000);
                });
            } else {
              weui.alert("请先绑定后台操作用户", function() {
                this.$router.push("/bind/warehousing/" + that.encodeToken);
              });
            }
          })
          .catch(err => {
            weui.topTips("获取用户信息失败", 2000);
          });
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    chooseExpress() {
      let that = this;
      weui.picker(this.ecPicker, {
        className: "custom-classname",
        container: "body",
        defaultValue: [""],
        onChange: function(result) {},
        onConfirm: function(result) {
          that.currExpressCompany = {
            _id: result[0].value,
            name: result[0].label
          };

          let loading = weui.loading("数据加载中", {
            className: "custom-classname"
          });
          let params = {
            worksiteId: that.worksiteId
          };
          if (result[0].value) {
            params.expressCompanyId = result[0].value;
          }
          // 重新加载数据
          axios
            .get("/api/expressTosend/toreturn", { params })
            .then(res => {
              loading.hide(function() {});
              if (res.data.success) {
                that.toReturns = res.data.data;
                if (that.toReturns.length == 0) {
                  that.haveData = false;
                } else {
                  that.haveData = true;
                }
                for (let i = 0; i < that.toReturns.length; i++) {
                  that.toReturns[i].inTime = moment(
                    that.toReturns[i].createdAt
                  ).format("YYYY-MM-DD HH:mm");
                }
              } else {
                weui.alert("获取待退送列表失败");
              }
            })
            .catch(err => {
              loading.hide(function() {});
              weui.alert("获取待退送列表失败");
            });
        },
        id: "expressCompanyPicker"
      });
    },
    scan(item) {
      let that = this;
      let title = "电话：" + item.receiverPhone;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let expressNo = "";
          let scanResult = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (scanResult.indexOf(",") >= 0) {
            // 扫描一维码的时候会返回一维码的编码规则
            expressNo = scanResult.substring(scanResult.indexOf(",") + 1);
          } else {
            expressNo = scanResult;
          }

          if (expressNo != item.expressNo) {
            weui.alert("快递单号不一致，请查证。");
            return;
          } else {
            weui.dialog({
              title: title,
              content: "单号：" + expressNo,
              className: "custom-classname",
              buttons: [
                {
                  label: "取消退送",
                  type: "default",
                  onClick: function() {}
                },
                {
                  label: "确定退送",
                  type: "primary",
                  onClick: function() {
                    let loading = weui.loading("处理中...", {
                      className: "custom-classname"
                    });
                    let params = {
                      _id: item._id,
                      expressNo: expressNo,
                      worksiteCode: that.userInfo.worksite.siteCode,
                      storageNo: item.storageNo,
                      tag: item.tag
                    };
                    axios
                      .put("/api/expressTosend/return", params)
                      .then(res => {
                        loading.hide(function() {});
                        if (!res.data.success) {
                          weui.toast(res.data.message);
                        }
                      })
                      .catch(err => {
                        loading.hide(function() {});
                        weui.alert("操作失败");
                      });
                  }
                }
              ]
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.return {
  font-size: 14px;
}
.warehousing {
  margin: 0 auto;
  position: relative;
  font-size: 16px;
}
.warehousing-header {
  text-align: center;
}
.warehousing-header-nav {
  margin-top: 20px;
  height: 33px;
  position: relative;
}
.warehousing-username {
  height: 50px;
  line-height: 50px;
  background-color: #1aad19;
  color: white;
  position: relative;
  font-size: 25px;
}
.worksite-info {
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  right: 0;
}
.school-name {
  line-height: 50px;
  margin-right: 10px;
  padding-top: 6px;
}
.weui-cells {
  margin-top: 0px;
}
.return-list {
  margin: 15px;
}
.return-item {
  border: 1px solid #eee;
  margin-top: 15px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px #1aad19;
  padding: 10px;
}
.item-middle-left_title {
  font-weight: bold;
  color: #1aad19;
}
.return-express {
  border-bottom: 1px solid #eee;
  font-size: 16px;
  padding-bottom: 6px;
  margin-bottom: 5px;
  color: orangered;
  font-weight: bold;
}
.scan-bnt {
  position: absolute;
  background-color: #1aad19;
  width: 60px;
  height: 60px;
  line-height: 60px;
  color: #ffffff;
  right: 30px;
  margin-top: -75px;
  text-align: center;
  border-radius: 10px;
}
.scan-bnt i {
  font-size: 30px;
}
.empty-data {
  text-align: center;
  margin-top: 30px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
.weui-dialog__title {
  font-size: 20px;
}
.weui-dialog__bd {
  font-size: 18px !important;
  padding-bottom: 0px;
  font-weight: bold;
  color: orangered;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/Return.vue